<template>
  <div>
    <order-summary
      v-if="order.scope_of_work && !order.orderType?.fromBom"
      :instructions="order.comment"
      :scope-of-work="order.scope_of_work"
    />
    <bom-order-items v-if="order.orderType?.fromBom" :order="order" />
  </div>
</template>

<script setup lang="ts">
import type { Order } from '@quotetome/materials-api'
import BomOrderItems from '@/components/boms/bom-order-items.vue'
import OrderSummary from '@/components/orders/order-summary.vue'

export interface Props {
  order: Order
}

defineProps<Props>()
</script>
